module.exports = __webpack_public_path__ + "img/hkCoverGlobal.5c4cc64e.png";